<template>
    <w-btn
        v-if="show"
        :color="error ? 'red' : 'blue-grey'"
        :loading="loading"
        :disabled="disabled"
        :text="$t('common.print')"
        :icon="error ? 'mdi-alert' : 'mdi-printer'"
        v-print="printObject"
    />
</template>

<script>
import {ref} from "vue";
import useSharedData from "@/use/SharedData";

export default {
    name: 'WBtnActivate',
    props: {
        show: Boolean,
        disabled: Boolean,
        error: Boolean,
        id: {type: String, default: "pdfqleditor"},
    },
    setup(props) {
        const  {loading} = useSharedData();

        const printObject = ref({
            id: props.id,
            previewTitle: false,
            beforeOpenCallback() {
                loading.value = true;
            },
            openCallback() {
                loading.value = false;
            },
            closeCallback() {
            },
        });

        return {
            printObject,
            loading,
        }
    }
}
</script>

<style scoped>

</style>